import Base from './Base'

class InstrumentAlarmNote extends Base {
  static className = 'InstrumentAlarmNote'
  static define() {
    this.hasOne('instrumentAlarmEvent')
    this.attributes('note')
  }
}

export default Base.createResource(InstrumentAlarmNote)
